import React, { useState, useEffect } from 'react';
import './Navbar.css';
import PropTypes from 'prop-types';

const Navbar = ({ isFixed }) => {
  const [time, setTime] = useState('');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('#about');

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const options = { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Europe/London' };
      const timeString = new Intl.DateTimeFormat('en-GB', options).format(now);
      setTime(`${timeString}`);
    };

    updateTime();
    const intervalId = setInterval(updateTime, 1000); // Update every second

    return () => clearInterval(intervalId); // Clean up the interval on unmount
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleLinkClick = (link, event) => {
    event.preventDefault();
    setActiveLink(link);
    const section = document.querySelector(link);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('section');
      let currentSection = activeLink;

      sections.forEach((section) => {
        const sectionTop = section.offsetTop - 50;
        if (window.scrollY >= sectionTop) {
          currentSection = `#${section.getAttribute('id')}`;
        }
      });

      setActiveLink(currentSection);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [activeLink]);

  return (
    <nav className={`navbar ${isFixed ? 'fixed' : ''}`}>
      <a href="#hero" className="logo" onClick={(e) => handleLinkClick('#about', e)}>
        PRATHU
      </a>
      <div className="location-time">NOTTINGHAM, UK {time}</div>
      <div className="status">AVAILABLE FOR FREELANCE WORKS</div>

      <div className="menu-icon" onClick={toggleMobileMenu}>
        MENU
      </div>

      <ul className="nav-links">
        <li>
          <a
            href="#about"
            className={activeLink === '#about' ? 'active' : ''}
            onClick={(e) => handleLinkClick('#about', e)}
          >
            ABOUT
          </a>
        </li>
        <li>
          <a
            href="#experience"
            className={activeLink === '#experience' ? 'active' : ''}
            onClick={(e) => handleLinkClick('#experience', e)}
          >
            EXPERIENCE
          </a>
        </li>
        <li>
          <a
            href="#contact"
            className={activeLink === '#contact' ? 'active' : ''}
            onClick={(e) => handleLinkClick('#contact', e)}
          >
            CONTACT
          </a>
        </li>
      </ul>

      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <ul className="mobile-menu-links">
            <li>
              <a
                href="#about"
                onClick={(e) => {
                  handleLinkClick('#about', e);
                  toggleMobileMenu();
                }}
              >
                ABOUT
              </a>
            </li>
            <li>
              <a
                href="#experience"
                onClick={(e) => {
                  handleLinkClick('#experience', e);
                  toggleMobileMenu();
                }}
              >
                EXPERIENCE
              </a>
            </li>
            <li>
              <a
                href="#contact"
                onClick={(e) => {
                  handleLinkClick('#contact', e);
                  toggleMobileMenu();
                }}
              >
                CONTACT
              </a>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};

Navbar.propTypes = {
  isFixed: PropTypes.bool,
};

export default Navbar;
